module.exports = __webpack_public_path__ + "static/img/8.85a5ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zddcf/8.png
// module id = 2sEo
// module chunks = 0